<template>
  <div class="fm-uplaod-container" :id="uploadId">
    <!-- <draggable class="drag-img-list"
      v-model="fileList"
      v-bind="{group: uploadId, ghostClass: 'ghost', animation: 200}"
      :no-transition-on-drag="true">-->
    <div
      :id="item.id"
      :style="{ width: width + 'px', height: height + 'px' }"
      :class="{
        uploading: item.status == 'uploading',
        'is-success': item.status == 'success',
        'is-diabled': disabledImg,
      }"
      class="upload-file"
      v-for="item in fileList"
      :key="item.id"
    >
      <img :src="item.url" />
      <el-progress
        v-if="item.status == 'uploading'"
        :width="miniWidth * 0.9"
        class="upload-progress"
        type="circle"
        :percentage="item.percent"
      ></el-progress>
      <label class="item-status" v-if="item.status == 'success'">
        <i class="el-icon-upload-success el-icon-check"></i>
      </label>
      <div
        class="uplaod-action"
        :style="{ height: miniWidth / 4 + 'px' }"
        v-if="
          hideImgPreviewBtn ||
          (isDelete && fileList.length > min && !disabledImg && !imgShowImg)
        "
      >
        <i
          v-if="hideImgPreviewBtn"
          class="su-icon-details"
          title="预览"
          @click="handlePreviewFile(item.id)"
          :style="{ 'font-size': miniWidth / 8 + 'px' }"
        ></i>
        <!--<i v-if="isEdit" class="iconfont icon-sync1" title="替换" @click="handleEdit(item.id)" :style="{'font-size': miniWidth/8+'px'}"></i>-->
        <i
          v-if="
            isDelete && fileList.length > min && !disabledImg && !imgShowImg
          "
          class="su-icon-delete"
          title="删除"
          @click="handleRemove(item.id)"
          :style="{ 'font-size': miniWidth / 8 + 'px' }"
        ></i>
      </div>
    </div>
    <!--</draggable>-->
    <el-button
      v-if="fileList.length && hideImgBatchDownloadBtn"
      :loading="ziploading"
      type="text"
      class="el-upload__tip"
      :style="{ float: 'right' }"
      @click="handleZIPDownload"
      >批量下载</el-button
    >
    <div
      class="el-upload el-upload--picture-card"
      v-if="!imgShowImg"
      :class="{ 'is-disabled': disabledImg }"
      v-show="fileList.length < length"
      :style="{ width: width + 'px', height: height + 'px' }"
      @click.self="handleAdd"
    >
      <i
        class="el-icon-plus"
        @click.self="handleAdd"
        :style="{
          fontSize: miniWidth / 4 + 'px',
          marginTop: -miniWidth / 8 + 'px',
          marginLeft: -miniWidth / 8 + 'px',
        }"
      ></i>
      <input
        :accept="getAllowableType"
        v-if="multiple"
        multiple
        ref="uploadInput"
        @change="handleChange"
        type="file"
        :style="{ width: 0, height: 0 }"
        name="file"
        class="el-upload__input upload-input"
      />
      <input
        :accept="getAllowableType"
        v-else
        ref="uploadInput"
        @change="handleChange"
        type="file"
        :style="{ width: 0, height: 0 }"
        name="file"
        class="el-upload__input upload-input"
      />
    </div>
  </div>
</template>

<script>
import Viewer from 'viewerjs'
import { config } from '../../config/config'
import { encrypt } from '../../util/crypto'
import fileUtils from '../../util/fileUtils'
import alertUtils from '../../util/alertUtils'
import request2 from '@/util/request2.js'
import { getCurDate } from '@/util/index'
require('viewerjs/dist/viewer.css')
export default {
  name: 'fm-upload',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    appId: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    length: {
      type: Number,
      default: 9,
    },
    isDelete: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    meitu: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showImg: {
      type: Boolean,
      default: false,
    },
    allowableType: {
      type: String,
      default: '',
    },
    widget: {
      type: Object,
      default: () => {},
    },
    yyid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ziploading: false,
      fileList: this.value || [],
      viewer: null,
      applicationId: this.appId,
      imgAction: this.action,
      uploadId: 'upload_' + new Date().getTime(),
      editIndex: -1,
      disabledImg: this.disabled,
      meituIndex: -1,
      imgShowImg: this.showImg,
      timeStr: '',
    }
  },
  created() {
    if (typeof this.applicationId !== 'undefined' && this.applicationId) {
      const dir = getCurDate()
      let allow = ''
      if (typeof this.allowableType !== 'undefined' && this.allowableType) {
        if (this.allowableType.indexOf('.') > -1) {
          allow = this.allowableType
        } else {
          const allowableTypeArr = this.allowableType.split(',')

          if (allowableTypeArr && allowableTypeArr.length > 0) {
            allowableTypeArr.map((item, index) => {
              allowableTypeArr[index] =
                index == allowableTypeArr.length - 1 ? `.${item}` : `.${item},`
            })
            const data = allowableTypeArr.join('')
            allow = data
          }
        }
      }
      this.timeStr = Date.now()
      const fileType = encrypt(allow, 'formflow' + this.timeStr)
      this.imgAction =
        config.fileBaseAPI +
        this.imgAction +
        '?appId=' +
        this.applicationId +
        '&dir=' +
        dir +
        '&fileType=' +
        encodeURIComponent(fileType)
    } else {
      this.disabledImg = true
    }
  },
  computed: {
    miniWidth() {
      if (this.width > this.height) {
        return this.height
      } else {
        return this.width
      }
    },
    hideImgBatchDownloadBtn() {
      if (process.env.VUE_APP_HIDE_IMG_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID) {
        return (
          process.env.VUE_APP_HIDE_IMG_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID.indexOf(
            this.yyid
          ) < 0
        )
      }
      return process.env.VUE_APP_HIDE_IMG_DOWNLOAD_BTN !== '1'
    },
    hideImgPreviewBtn() {
      const yyid =
        process.env.VUE_APP_HIDE_IMG_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID || ''
      if (
        yyid.indexOf('ENV_APP_HIDE_IMG_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID') > -1
      ) {
        return true
      }
      if (yyid && yyid !== '') {
        return yyid.indexOf(this.yyid) < 0
      }
      return true
    },
    getAllowableType() {
      if (this.allowableType) {
        if (this.allowableType.indexOf('.') > -1) {
          return this.allowableType
        } else {
          const allowableTypeArr = this.allowableType.split(',')

          if (allowableTypeArr && allowableTypeArr.length > 0) {
            allowableTypeArr.map((item, index) => {
              allowableTypeArr[index] =
                index == allowableTypeArr.length - 1
                  ? `image/${item}`
                  : `image/${item},`
            })
            const allow = allowableTypeArr.join('')
            return allow
          }
        }
      }
      return 'image/*'
    },
  },
  mounted() {
    this.$emit('input', this.fileList)
  },
  methods: {
    handleZIPDownload() {
      const data = { componentName: this.widget.name, items: this.fileList }
      this.fileZIPDownload(data)
    },
    fileZIPDownload(data) {
      this.ziploading = true
      request2({
        url: config.baseAPI + '/v1/file/zip/download',
        method: 'post',
        data: data,
        responseType: 'blob',
      })
        .then(res => {
          const blob = res.data
          if (!blob) {
            alertUtils.alertError('文件下载错误', true)
            return
          }
          const filename = this.widget.name + '.zip'

          const url = window.URL.createObjectURL(blob)
          this.download(url, filename)
        })
        .finally(() => {
          this.ziploading = false
        })
    },
    download(blobUrl, filename) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = filename
      a.href = blobUrl
      a.click()
    },
    handleChange() {
      const files = Array.from(this.$refs.uploadInput.files)
      const MB = 1024 * 1024
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > this.widget.options.maxSize * MB) {
          alertUtils.alertWarning(
            `文件限制最大为${this.widget.options.maxSize}Mb,文件${
              files[i].name
            }约为${parseFloat(files[i].size / MB).toFixed(2)}Mb`,
            true
          )
          files.splice(i, 1)
        }
      }
      if (!files.length) {
        return
      }
      if (files.length + this.fileList.length > this.length) {
        alertUtils.alertWarning('超过图片上传最大数', true)
        return
      }
      let index = this.editIndex
      const fileLength = files.length
      let ending = false
      for (let i = 0; i < fileLength; i++) {
        const file = files[i]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          if (this.editIndex >= 0) {
            this.fileList[this.editIndex].percent = 0
            this.fileList[this.editIndex].status = 'uploading'
            this.editIndex = -1
          } else {
            this.fileList.push({
              percent: 0,
              status: 'uploading',
            })
            index = this.fileList.length - 1
          }
          this.$nextTick(() => {
            if (i >= fileLength - 1) {
              ending = true
            }
            this.uploadAction(file, index, ending)
          })
        }
      }
      this.$refs.uploadInput.value = []
    },
    uploadAction(file, index, ending) {
      const xhr = new XMLHttpRequest()
      const url = this.imgAction
      xhr.open('POST', url, true)
      const token = localStorage.getItem('Admin-Token')
      xhr.setRequestHeader('X-Id-Token', token)
      const visitor = sessionStorage.getItem('visitor')
      xhr.setRequestHeader('visitor', visitor)
      xhr.setRequestHeader('timeStr', this.timeStr)
      const formData = new FormData()
      formData.append('file', file)
      xhr.send(formData)
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const resData = JSON.parse(xhr.response)
          if (
            resData &&
            resData.status === 200 &&
            resData.data &&
            resData.data.id
          ) {
            this.$set(this.fileList, index, {
              ...this.fileList[index],
              id: resData.data.id,
              name: file.name,
              url:
                config.fileBaseAPI +
                '/api/v1/file/service/file-upload/view-img?id=' +
                resData.data.id,
              percent: 100,
            })
            setTimeout(() => {
              const arr = JSON.parse(JSON.stringify(this.fileList))
              arr[index] = { ...this.fileList[index], status: 'success' }
              this.fileList = arr
            }, 200)
          } else {
            alertUtils.alertError(resData.message, true)
            const arr = JSON.parse(JSON.stringify(this.fileList))
            arr[index] = { ...this.fileList[index], status: 'error' }
            this.fileList = arr
          }
          if (ending) {
            // 判断所有文件上传结束了
            for (let i = 0; i < this.fileList.length; i++) {
              // 删除上传失败的
              if (this.fileList[i].status === 'error') {
                this.fileList.splice(i, 1)
                i--
              }
            }
          }
        }
      }
    },
    handleRemove(id) {
      if (this.fileList && id) {
        fileUtils.imgDeleted(id, this.fileList)
      } else {
        alertUtils.alertError('图片删除错误', true)
      }
    },
    handleEdit(id) {
      this.editIndex = this.fileList.findIndex(item => item.id === id)
      this.$refs.uploadInput.click()
    },
    handleMeitu(id) {
      this.$emit(
        'on-meitu',
        this.fileList.findIndex(item => item.id === id)
      )
    },
    handleAdd() {
      if (!this.disabledImg) {
        this.editIndex = -1
        this.$refs.uploadInput.click()
      }
    },
    handlePreviewFile(id) {
      this.viewer && this.viewer.destroy()
      this.uploadId = 'upload_' + new Date().getTime()
      this.$nextTick(() => {
        this.viewer = new Viewer(document.getElementById(this.uploadId))
        this.viewer.view(this.fileList.findIndex(item => item.id === id))
      })
    },
  },
  watch: {
    fileList(newVal, oldVal) {
      if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
        return
      }
      this.$emit('input', newVal)
      this.$emit('change')
    },
    value(newVal, oldVal) {
      if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
        return
      }
      this.fileList = JSON.parse(JSON.stringify(newVal))
    },
    disabled: {
      // 修复使用changeOptions方法设置图片组件是否禁用不生效
      handler(val) {
        this.disabledImg = val
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.fm-uplaod-container {
  .is-disabled {
    position: relative;

    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      // background: rgba(0,0,0,.1);
      content: '';
      display: block;
      cursor: not-allowed;
    }
  }

  .upload-file {
    margin: 0 10px 10px 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    // background: #fff;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;
    vertical-align: top;
    &:hover {
      .uplaod-action {
        display: flex;
      }
    }
    .uplaod-action {
      position: absolute;
      // top: 0;
      // height: 30px;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      display: none;
      justify-content: center;
      align-items: center;
      i {
        color: #fff;
        cursor: pointer;
        margin: 0 5px;
      }
    }
    &.is-success {
      .item-status {
        position: absolute;
        right: -15px;
        top: -6px;
        width: 40px;
        height: 24px;
        background: #13ce66;
        text-align: center;
        transform: rotate(45deg);
        box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
        & > i {
          font-size: 12px;
          margin-top: 11px;
          color: #fff;
          transform: rotate(-45deg);
        }
      }
    }
    &.uploading {
      &:before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
      }
    }
    .upload-progress {
      position: absolute;
      .el-progress__text {
        color: #fff;
        font-size: 16px !important;
      }
    }
    img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
  .el-upload--picture-card {
    position: relative;
    overflow: hidden;
    .el-icon-plus {
      position: absolute;
      top: 50%;
      left: 50%;
    }
  }
  .upload-input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    opacity: 0;
    cursor: pointer;
  }

  .drag-img-list {
    display: inline;
    .ghost {
      position: relative;
      &::after {
        width: 100%;
        height: 100%;
        display: block;
        content: '';
        background: #fbfdff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 1px dashed #3bb3c2;
      }
    }
    & > div {
      cursor: move;
    }
  }
}

.viewer-container {
  z-index: 9999 !important;
}
</style>
